import Api from '../utils/Api';

const confirmEmail = (caller, token) => {
    return Api.makeRequest(`/confirm-email/${token}`, 'POST', {}, caller, token);
};

const forgottenPassword = (caller, data) => {
    return Api.makeRequest("/forgotten-password", 'POST', data, caller, data);
};

const login = (caller, data) => {
    return Api.makeRequest("/login", 'POST', data, caller, data)
        .then( (data) => {
            return Api.handleLogin(data);
        })
};

const resetPassword = (caller, data) => {
    return Api.makeRequest(`/reset-password/${data.token}`, 'POST', {
        token: data.token,
        newPassword: data.newPassword
    }, caller, data);
};

const closeCookieMessage = (caller) => {
    localStorage.setItem('cookie-disclaimer-closed', true);
    return {};
};

export { confirmEmail, resetPassword, login, forgottenPassword, closeCookieMessage };


// WEBPACK FOOTER //
// ./src/models/Util.js